// extracted by mini-css-extract-plugin
module.exports = {"station-widgets":"StationWidgets_station-widgets__2uYWq","fallback":"StationWidgets_fallback__2FVKT"};